export default __webpack_public_path__ + "static/media/46t.8f10c52d.jpg";